import { fadeInUp } from "../../../animations/fadeVariants";
import ExperienceItem from "../../common/ExperienceItem";
import { experience_list } from "./experience_data";
import "./style.css";
import { motion } from "framer-motion";
const Experience = () => {
  return (
    <section id="experience" className="experience">
      <motion.div {...fadeInUp}>
        <h1 className="title">Experience</h1>
      </motion.div>
      <div className="exp-collection">
        {experience_list.map((item, key) => {
          return (
            <ExperienceItem
              key={key}
              beginYear={item.beginYear}
              endYear={item.endYear}
              title={item.title}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Experience;
